import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

/**
 * Loading indicator shown when fetching chat history.
 * Distinct from TypingIndicator which is shown when AI is generating a response.
 */
export const HistoryLoadingIndicator = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="flex flex-col items-center justify-center py-12"
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid="history-loading-indicator"
    >
      <Loader2
        className="h-8 w-8 text-muted-foreground animate-spin"
        aria-hidden="true"
      />
      <p className="mt-3 text-sm text-muted-foreground">
        Loading conversation...
      </p>
      <span className="sr-only">Loading chat history, please wait</span>
    </motion.div>
  );
};
